module.exports = __webpack_public_path__ + "static/media/igor_rudim.fe59ada2.jpg";